import _get from 'hs-lodash/get';
import { useContext, useEffect, useRef } from 'react';
import { PROPERTY_REFERENCE_TYPES } from '../constants/associations';
import { pluralTypeToSingle } from '../constants/types';
import { PropertiesContext } from '../contexts/properties/context';
const useSelectLinkedProperties = ({
  referenceType,
  correlatedField,
  selectValue,
  objectType,
  onFormValueChanged
}) => {
  const prevCurrentSelectValue = useRef(selectValue);
  const {
    externalOptions
  } = useContext(PropertiesContext);

  // set value to correlated field
  useEffect(() => {
    if (correlatedField && referenceType === PROPERTY_REFERENCE_TYPES.PIPELINE && selectValue && prevCurrentSelectValue.current !== selectValue) {
      prevCurrentSelectValue.current = selectValue;
      const pipelineEntity = _get(externalOptions[pluralTypeToSingle[objectType]][referenceType], 'results', []).find(entity => entity.id === selectValue);
      if (pipelineEntity) {
        const pipelineStageNewValue = _get(pipelineEntity.additionalFields, 'defaultPipelineStageId', '');
        if (pipelineStageNewValue) {
          onFormValueChanged({
            key: correlatedField.relatedProperty,
            value: pipelineStageNewValue,
            required: true
          });
        }
      }
    }
  }, [correlatedField, selectValue, externalOptions, objectType, onFormValueChanged, referenceType]);
};
export default useSelectLinkedProperties;